import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-notification-content',
  standalone: true,
  imports: [],
  templateUrl: './notification-content.component.html',
  styleUrl: './notification-content.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
// eslint-disable-next-line @tseslint/no-extraneous-class
export class NotificationContentComponent {}
